const ThumbSlideshow = (() => {
    const TIME_PER_SLIDE = 1000;
    const TRANSITION_DURATION= 500;
    let slideInterval = null;
    var $window = $(window);

    $.fn.queueAddClass = function(className) {
        this.queue('fx', function(next) {
            $(this).addClass(className);
            next();
        });
        return this;
    };

    $.fn.queueRemoveClass = function(className) {
        this.queue('fx', function(next) {
            $(this).removeClass(className);
            next();
        });
        return this;
    };

    const playSlideshow = (images, totalSlides) => {
        for (let i = 0; i < totalSlides; i++ ) {
            const extraDelay = (i === totalSlides - 1) ? 0 : TRANSITION_DURATION;
            $(images[i])
                .delay(i * TIME_PER_SLIDE)
                .queueAddClass('show')
                .delay(TIME_PER_SLIDE + extraDelay)
                .queueRemoveClass('show');
        }
    };

    const startSlideshow = images => {
        const totalSlides = images.length;

        if (totalSlides) {
            playSlideshow(images, totalSlides);
            slideInterval = setInterval(() => {
                playSlideshow(images, totalSlides);
            }, totalSlides * TIME_PER_SLIDE + TIME_PER_SLIDE);
        }
    };

    const stopSlideshow = images => {
        $(images).stop();
        $(images).removeClass('show');
        clearInterval(slideInterval);
    };

    const getThumbnails = () => $('.thumbnail .href-wrapper');

    const addThumbnailsEvents = () => {
        getThumbnails().each((index, el) => {
            const slideshowImages = $(el).find('.slideshow-image');
            if (slideshowImages.length) {
                $(el).on('mouseover', () => startSlideshow(slideshowImages));
                $(el).on('mouseout', () => stopSlideshow(slideshowImages));
            }
        });
    };

    const removeThumbnailsEvents = () => {
        getThumbnails().each((index, el) => {
            const slideshowImages = $(el).find('.slideshow-image');
            if (slideshowImages.length) {
                $(el).off();
                $(el).off();
            }
        });
    };

    const registerEvents = () => {
        $window.on('load', addThumbnailsEvents);
        $window.on('loadContent', addThumbnailsEvents);
        $window.on('unloadContent', removeThumbnailsEvents);
    };

    const init = () => {
        registerEvents();
    };

    return {
        init: init
    }

})();
